import { server } from '../../../core/engine/server'
import { modal } from '../../../core/utilities/modal'

var QuickBooksHandler = Class.create({
  	initialize: function() {},
    generateIncomeLoseReport: function(callback) {
		var url = "integrations/quickbooks/reports/profitloss/download"
		server.getFile(url,null,true, function(success){
            if(success && !success.status) {
                callback();
            } else {
                modal.showInfo("Oops! Failed to download pdf.", "danger", "top", "center");
            }
        });
    },
    generateProfitLossPrevYearReport: function(callback) {
		var url = "integrations/quickbooks/reports/profitlossprevyear/download"
		server.getFile(url,null,true, function(success){
            if(success && !success.status) {
                callback();
            } else {
                modal.showInfo("Oops! Failed to download pdf.", "danger", "top", "center");
            }
        });
    },
    generateQWCCertification: function(callback) {
		var self = this;
		var url = "integrations/quickbooks/certification/generate"
		server.getFile(url,null,true, function(success){
            if(success && !success.status) {
                callback();
            } else {
                modal.showInfo("Oops! Failed to download pdf.", "danger", "top", "center");
            }
        });
    },
    getStatusOfLossIncomeReport: function(callback) {
		var self = this;
		var url = "integrations/quickbooks/reports/profitloss/status";
		server.getData(url,null,true).then(function(response) {
            if(response) {
                callback(response.data);
            } else {
                modal.showInfo("Oops! Something went wrong, try to refresh.", "danger", "top", "center");
            }
        });
    },
    getStatusOfLossIncomePrevYearReport: function(callback) {
		var self = this;
		var url = "integrations/quickbooks/reports/profitlossprevyear/status";
		server.getData(url,null,true).then(function(response) {
            if(response) {
                callback(response.data);
            } else {
                modal.showInfo("Oops!", "Something went wrong, try to refresh.", "danger", "top", "center");
            }
        });
    },
    getLastActivity: function(callback) {
		var self = this;
		var url = "integrations/quickbooks/activity";
		server.getData(url,null,true).then(function(response) {
            if(response) {
                callback(response.data);
            } else {
                modal.showInfo("Oops!", "Something went wrong, try to refresh.", "danger", "top", "center");
            }
        });
    },
    queueReport: function(type, callback) {
		var url = "integrations/quickbooks/report/generate/" + type;
		var data = server.getData(url, null, false, 'POST');
            data
            .done(function(response){
                if(callback) {
                    callback();
                }
            })
            .fail(function(e){
                modal.resetBackDrop();
                modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
            });
    },
    getReport: function(reportType, callback) {
		var url = "integrations/quickbooks/reports/" + reportType;
        var data = server.getData(url,null,true);
            data.done(function(response) {
                if(response && response.status != 'PENDING') {
                    callback(response.report);
                } else {
                    modal.showInfo("Report not ready.  We are waiting on QuickBooks Desktop to return a response.", "warning", "top", "center");
                }
            })
            .fail(function(e){
                modal.resetBackDrop();
                modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
            });
    },
    getData: function(callback) {
		var url = "integrations/quickbooks/logs";
        var data = server.getData(url,null,true);
            data.done(function(response) {
                callback(response);
            })
            .fail(function(e){
                modal.resetBackDrop();
                modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
            });
    },
    runAction: function(actionType, callback) {
		var url = "integrations/quickbooks/action/" + actionType;
        var data = server.getData(url, null, true, 'POST');
            data.done(function(response) {
                if(response && response.status != 'PENDING') {
                    callback(response.report);
                } else {
                    modal.showInfo("Action not ready.  We are waiting on QuickBooks Desktop to return a response.", "warning", "top", "center");
                }
            })
            .fail(function(e){
                modal.resetBackDrop();
                modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
            });
    },
    exportCsv: function(reportType, callback) {
		var url = "integrations/quickbooks/reports/" + reportType + "/export";
        server.getFile(url,null,true, function(success){
            if(success && !success.status) {
                callback();
            } else {
                modal.showInfo("Oops! Failed to download csv.", "danger", "top", "center");
            }
        });
    },
    crossReferenceBuildings: function(data, callback) {
        var url = "integrations/quickbooks/crossreference/buildings";
        const params = {
            reportData: data
        };
        var data = server.getData(url, params,true, 'POST');
        data.done(function(response) {
            if(response) {
                callback(response);
            } else {
                modal.showInfo("Report not ready.  We are waiting on QuickBooks Desktop to return a response.", "warning", "top", "center");
            }
        })
        .fail(function(e){
            modal.resetBackDrop();
            modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
        });
    },
    addTenantsFromQBImport: function(log, callback) {
		var url = "integrations/quickbooks/import/tenants";
        var data = server.getData(url, log, true, 'POST');
        data.done(function(response) {
            if(response && response.status != 'PENDING') {
                callback(response.report);
            } else {
                modal.showInfo("Action not ready.  We are waiting on QuickBooks Desktop to return a response.", "warning", "top", "center");
            }
        })
        .fail(function(e){
            modal.resetBackDrop();
            modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
        });
    },
    addPaymentsFromQB: function(log, callback) {
		var url = "integrations/quickbooks/import/payments";
        var data = server.getData(url, log, true, 'POST');
        data.done(function(response) {
            if(response && response.status != 'PENDING') {
                callback(response.report);
            } else {
                modal.showInfo("Action not ready.  We are waiting on QuickBooks Desktop to return a response.", "warning", "top", "center");
            }
        })
        .fail(function(e){
            modal.resetBackDrop();
            modal.showInfo("Oops! " + e.responseText, "danger", "top", "center");
        });
    },
});

export let quickBooksHandler = new QuickBooksHandler();


// WEBPACK FOOTER //
// app/helpers/Integrations/QuickBooks/QuickBooksHandler.js